// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"rL-z","upvoteIcon":"sL-z","downvoteIcon":"tL-z","feedbackIcon":"uL-z"};